import { http } from "./http.js";

async function getEmployee(resource, id) {
  const response = await http.get(`/${resource}/${id === "0" ? "new" : id}`);
  return response;
}

async function updateEmployee(resource, id, contactPerson) {
  const response = await http.put(`/${resource}/${id}`, contactPerson);
  return response;
}

async function createEmployee(resource, contactPerson) {
  const response = await http.post(`/${resource}`, contactPerson);
  return response;
}

async function changeRemovedState(resource, id, isRemoved) {
  const response = await http.patch(
    `/${resource}/${id}/rpc/change-removed-state`,
    {
      value: !isRemoved,
    },
  );
  return response;
}

export { getEmployee, changeRemovedState, updateEmployee, createEmployee };
